module.exports = __webpack_public_path__ + "static/power-img3-3-a533f8377022905d87f324509418658d.png";